import { Outlet, useParams } from 'react-router-dom'
import Header from '../../components/Header/Header'
import SearchForm from '../../components/SearchForm/SearchForm'
import './Layout.scss'
import classNames from 'classnames'

export default function Layout() {
	const { keyword } = useParams()

	return (
		<div className={classNames('layout', {
			'layout__keyword': keyword !== undefined
		})}>
			<Header />

			{!keyword && <SearchForm />}
			<Outlet />
		</div>
	)
}
